<template>
    <section>
        <navigation  :activeTab='"login"'></navigation>
        <div class="mdl-grid center-items">
          <div class="mdl-cell mdl-cell--12-col center-items"> 
            <h5 class="center-align">Login</h5>
            <section id="firebaseui-auth-container"></section>
            <p class="center-align"> 
              For more info on KBO Fantasy Leagues, see <a href="/rules">How To Play</a>
            </p>
          </div>
        </div>
    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";
import firebase from "firebase";
import firebaseui from "firebaseui";

export default {
    name: "Login",
    data() {
        return {};
    },
    components: {
        navigation
    },
    mounted() {
        let ui = firebaseui.auth.AuthUI.getInstance();
        if (!ui) {
            ui = new firebaseui.auth.AuthUI(firebase.auth());
        }
        var uiConfig = {
          signInSuccessUrl: '/',
          signInOptions: [
            // Leave the lines as is for the providers you want to offer your users.
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.EmailAuthProvider.PROVIDER_ID
          ],
          credentialHelper: firebaseui.auth.CredentialHelper.NONE,
          // tosUrl and privacyPolicyUrl accept either url string or a callback
          // function.
          // Terms of service url/callback.
          tosUrl: '/tos',
          // Privacy policy url/callback.
          privacyPolicyUrl: function() {
            window.location.assign('/privacy');
          }
        };
        ui.start("#firebaseui-auth-container", uiConfig);
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue